<template>
  <v-layout column elevation-3 pa-2>
    <v-layout>
      <h4 class="display-1">
        Vendor name: {{ vendor.name }}
      </h4>
      <v-spacer />
      <v-btn>Edit</v-btn>
      <v-btn color="error" @click="$emit('remove', vendor.id)">
        Delete
      </v-btn>
    </v-layout>
    <v-layout
      column
      wrap
      ml-5
      class="limit-height"
    >
      <v-flex my-1>
        Category: {{ vendor.category }}
      </v-flex>
      <v-flex my-1>
        Phone: {{ vendor.phone | displayPhone }}
      </v-flex>
      <v-flex my-1>
        Email: {{ vendor.email }}
      </v-flex>
      <v-flex my-1>
        Insurance Provider: {{ vendor.insurance }}
      </v-flex>
      <v-flex my-1>
        Expires: {{ vendor.expires | formatDate }}
      </v-flex>
      <v-flex my-1>
        Website: https://{{ vendor.website }}
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'Vendor',
  filters: {
    displayPhone: phone => `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(
      6,
    )}`,
    formatDate: date => date && dayjs(date).format('MMMM D, YYYY'),
  },
  props: {
    vendor: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style>
.limit-height {
  max-height: 100px
}
</style>
